export class CreatePolicyScheduleInput {
    'vaultId';
    'region';
    'windows';
    'useUtc';
    'duration';
    'backupRetention';
    'scheduleType';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "windows",
            "baseName": "windows",
            "type": "string",
            "format": ""
        },
        {
            "name": "useUtc",
            "baseName": "useUtc",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "duration",
            "baseName": "duration",
            "type": "number",
            "format": ""
        },
        {
            "name": "backupRetention",
            "baseName": "backupRetention",
            "type": "number",
            "format": ""
        },
        {
            "name": "scheduleType",
            "baseName": "scheduleType",
            "type": "ScheduleType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreatePolicyScheduleInput.attributeTypeMap;
    }
    constructor() {
    }
}
